
import josip from '../assets/imgs/lopizic.png';
import simlesa from '../assets/imgs/simlesa.png'
import lugovic from '../assets/imgs/lugovic.png'

export const greetings = {
    'josip-lopizic':{
        name:"Josip Lopižić",
        title:"mr. spec.",
        section_title:"Pozdravna riječ predsjednika Hrvatskog psihološkog društva",
        description:"Predsjednik Hrvatskog psihološkog društva",
        link:'/pozdravna-rijec/josip-lopizic',
        image: josip,
        image_vert:josip,
        text: "Poštovane kolegice, poštovani kolege,\n\n\
S posebnim zadovoljstvom,  najavljujemo i pozivamo vas na još jednu godišnju konferenciju \
hrvatskih psihologa s međunarodnim sudjelovanjem koja će se, nakon 20 godina, po drugi put \
održati u Vodicama, u Kongresnom centru Hotela Olympia, od 4. do 7. studenoga 2026. godine.\
Središnja tema ove konferencije je „ Mentalno zdravlje za sve: uloga psihologije u dostupnoj \
i kvalitetnoj podršci”. I na ovoj konferenciji, ponovno se bavimo mentalnim zdravljem s obzirom \
na brojne izazove i krize s kojima se kao pojedinci i društvo svakodnevno susrećemo i suočavamo. \
Kakav je utjecaj svih tih izazova na naš svakodnevni život, kako se s njima nosimo i koje su posljedice \
koje kao pojedinci i zajednica proživljavamo samo su dio važnih pitanja na koje ćemo kroz različite \
oblike rada pokušati odgovoriti na ovoj konferenciji. Ali, s obzirom na glavnu temu, stavit ćemo poseban \
naglasak i na naše resurse i čimbenike otpornosti koji su važni za suočavanje i uspješno nošenje te \
prevladavanje različitih kriznih situacija koje svakodnevno živimo. Kao i na svakoj konferenciji, \
dobrodošli su i drugi sadržaji s kojima se kao struka bavimo i koji nisu izravno povezani s glavnom \
temom konferencije. Ova 33. godišnja konferencija, naš godišnji susret u Vodicama, tradicionalno \
je izvrsna prilika za susret kolegica i kolega, za nova učenja vezanima ponajprije za psihologijsku \
praksu ali i za upoznavanje s novim područjima psihologijske djelatnosti i izazovima koji su pred nama. \
Konferencije su oduvijek bile središnji godišnji skupovi psihologinja i psihologa te mjesta druženja i \
susreta kolega i prijatelja. Naši ljubazni domaćini, osobelje Hotela Olympia kao i kolegice i kolege s \
područja Šibensko-kninske županije, najavljuju i vrlo lijepi društveni program.\n\
Dobrodošli u Vodice, dobrodošli na 33. godišnju konferenciju hrvatskih psihologa!\n\n\
Josip Lopižić, predsjednik Hrvatskog psihološkog društva"
    },
    'sanja-simlesa':{
        name:"Sanja Šimleša",
        title:"izv. prof. dr. sc.",
        section_title:"Pozdravna riječ predsjednice Programskog odbora",
        description:"Predsjednica Programskog odbora",
        link:'/pozdravna-rijec/sanja-simlesa',
        image: simlesa,
        image_vert: simlesa,
        text:"Poštovane kolegice i kolege,\n\n\
u ime Programskog odbora s posebnim zadovoljstvom pozivam vas na Godišnju konferenciju \
hrvatskih psihologa 2026., pod nazivom Mentalno zdravlje za sve: uloga psihologije u dostupnoj \
i kvalitetnoj podršci.\n\n\
Nakon prošlogodišnje konferencije u Splitu, na kojoj smo otvorili važne rasprave o suvremenim \
izazovima mentalnog zdravlja i ulozi psihologije u vremenu društvenih promjena, ovogodišnja \
se konferencija prirodno nadovezuje na ta promišljanja te produbljuje pitanja kako osigurati da \
psihološka podrška bude doista dostupna, uključiva i kvalitetna za sve koji je trebaju. Tema \
konferencije 2026. godine usmjerena je na izazove s kojima se mnogi od nas svakodnevno \
susreću u različitim područjima psihološke prakse, osobito na prepreke u pristupu psihološkoj \
podršci i sustavima skrbi u različitim okruženjima, uključujući zdravstvene, obrazovne, radne i \
druge društvene kontekste. Ovaj skup ujedno predstavlja nastavak i produbljenje tema \
otvorenih na prošlogodišnjoj konferenciji u Splitu, koja je zaključena zajedničkom porukom više \
od 600 psihologinja i psihologa o zabrinjavajućim društvenim trendovima, uključujući porast \
nasilja i potrebu za dostupnijim i odgovornijim sustavima skrbi za mentalno zdravlje.\n\n\
Suvremene teškoće mentalnog zdravlja sve se češće prepoznaju kao rezultat složenog \
međudjelovanja osobnih, razvojnih i društvenih čimbenika. Posljednjih godina svjedočimo i \
razvoju novih konceptualnih okvira, promjenama u jeziku kojim govorimo o teškoćama i \
potrebama te sve većem naglasku na kontekst, prava i subjektivna iskustva pojedinaca. Ujedno \
živimo u razdoblju povećane globalne neizvjesnosti i društvenih napetosti koje dodatno utječu \
na osjećaj sigurnosti, stabilnosti i dobrobiti pojedinaca i zajednica. Takve promjene potiču nas \
da, uz individualni rad, promišljamo i šire kontekste u kojima ljudi žive. U tom prostoru \
psihologija ima važnu ulogu u prepoznavanju prepreka, zagovaranju pristupačnih i pravednih \
sustava te razvoju kvalitetnih, osjetljivih i održivih oblika podrške.\n\n\
Konferenciju vidimo kao mjesto susreta različitih profesionalnih iskustava i pristupa, otvorenog \
razgovora i zajedničkog promišljanja o ulozi psihologije, ali i drugih srodnih struka u \
suvremenom društvu. Uz znanstveni i stručni program, vjerujemo da su važni i neformalni \
trenuci – druženje, glazba i ples u konferencijskom prostoru – koji mogu pridonijeti ugodnoj \
atmosferi i učiniti duge konferencijske dane ljepšima. Upravo zato posebnu ćemo pažnju \
posvetiti i tim dijelovima programa.\n\n\
Pozivamo vas da svojim znanstvenim i stručnim doprinosima sudjelujete u oblikovanju \
programa konferencije te da nam se pridružite na susretu koji povezuje različite stručnjake \
psihološke zajednice i srodnih struka.\n\n\
Radujemo se vašem sudjelovanju i susretu 2026. godine. \
Srdačno, \
Izv. prof. dr. sc. Sanja Šimleša, predsjednica Programskog odbora Godišnje konferencije hrvatskih psihologa 2026."
    },
    'gina-lugovic':{
        name:"Gina Lugović",
        title: "dr.sc.",
        section_title:"Pozdravna riječ predsjednice Organizacijskog odbora",
        description:"Predsjednica Organizacijskog odbora",
        link:'/pozdravna-rijec/gina-lugovic',
        image: lugovic,
        image_vert: lugovic,
        text:'Poštovane kolegice i kolege,\n\n\
Vraćamo se nakon dvadeset godina u Vodice. Okrugli brojevi su nam uvijek dobar izgovor za \
druženja, sjećanja, ali i za učenje i uživanje. Od te 2006. godine, kada smo zadnji put ovdje \
boravili, puno toga se promijenilo. Doživjeli smo ugodna i manje ugodna iskustva, borili se sa \
sobom i svijetom, stekli neprocjenjiva znanja, a u međuvremenu su stasale i nove generacije \
koje nastavljaju naše puteve, unoseći novu energiju u našu struku.\n\n\
Čast mi je i veliko zadovoljstvo pozdraviti vas u ime Organizacijskog odbora 33. godišnje \
konferencije hrvatskih psihologa. Središnja tema našeg ovogodišnjeg susreta, "Mentalno \
zdravlje za sve: uloga psihologije u dostupnoj i kvalitetnoj podršci", poziva nas da \
promišljamo o našoj odgovornosti prema svakom pojedincu i društvu u cjelini. \n\n\
U već tradicionalnom stilu, želimo da se ovdje, u neposrednoj blizini Velike Mrdakovice i \
njezine antičke povijesti, osjećate zadovoljno, sretno i nadahnuto. Neka vas tišina starih \
liburnskih nekropola podsjeti na trajnost ljudske prirode, a novi izazovi potiču na \
profesionalni rast.\n\n\
Kao stručnjaci koji stoje uz djecu, mlade, obitelji i starije, svakodnevno svjedočimo njihovim \
suočavanjima sa životnim olujama. Često smo i sami poput Vrančićevog „homo volansa“ - \
koristimo svoj znanstveni i ljudski padobran kako bismo sigurno skočili u nepoznata područja \
ljudske psihe, uvijek s ciljem da osiguramo dostupnu i kvalitetnu podršku onima u potrebi. \
Taj skok u nepoznato radimo svakodnevno, jer vjerujemo da mentalno zdravlje ne smije biti \
privilegija, već pravo dostupno svima.\n\n\
Želja nam je da vas ova konferencija podsjeti zašto ste odabrali ovaj poziv - da vas održi \
mladima, poletnima i izdržljivima. Naš je zadatak razumjeti kontekst, povezati niti i \
doprinijeti procesima zacjeljivanja pojedinca i zajednice kroz vrhunsku psihološku djelatnost. \
Uz miris mora i ugodan ambijent hotela Olympia, napunimo baterije za sve osobne i \
profesionalne izazove koji su pred nama.\n\n\
Vi samo dođite, a za sve ostalo ćemo se pobrinuti mi. Do skorog susreta u Vodicama!\n\n\
Gina Lugović, predsjednica Organizacijskog odbora'
    }
    
}
